import { useState } from 'react'
import { dataConstants } from 'services/redux/data/constants'
import useDeepCompareEffect from 'use-deep-compare-effect'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import { routeBookingConstants } from 'utils/constants/route/RouteBookingConstants'
import HelperTimeslotGroups from 'utils/helper/HelperTimeslotGroups'
import HelperLocation from 'utils/HelperLocation'
import store from 'services/redux/store'

const generateTimeslotGroups = ( _timeslotGroups, _timeslotKinds, _buildings, _floors, _rooms, _forcedGuids ) => {
	let collectedData = {};
	
	_.forEach( _.sortBy( _timeslotGroups, [ 'position' ] ), ( timeslotGroup ) => {
		if( _.get( _forcedGuids, routeBookingConstants.FORCED_TIMESLOT_GROUP_GUID, timeslotGroup.guid ) !== timeslotGroup.guid ) {
			return true;
		}
		
		const { timeslotKinds, timeslotSubKinds } = HelperTimeslotGroups.getKindsAndSubKinds( timeslotGroup, _timeslotKinds );
		
		const buildingTree = HelperLocation.buildTree(
			_.cloneDeep( _buildings ),
			_.cloneDeep( _floors ),
			_.cloneDeep( _rooms ),
			_.cloneDeep( timeslotKinds ),
			_.cloneDeep( timeslotSubKinds ),
			_.cloneDeep( _forcedGuids )
		)
		
		collectedData[ timeslotGroup.guid ] = {
			..._.cloneDeep( timeslotGroup ),
			buildingTree,
		};
	});
	
	return collectedData;
}

const useSelectTimeslotGroups = ( _forcedGuids ) => {
	const _timeslotGroups = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_GROUPS];
	} ); // do not remove, required for reloading
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} ); // do not remove, required for reloading
	const _buildings = useSelector( state => {
		return state.data[dataConstants.BUILDINGS];
	} ); // do not remove, required for reloading
	const _floors = useSelector( state => {
		return state.data[dataConstants.FLOORS];
	} ); // do not remove, required for reloading
	const _rooms = useSelector( state => {
		return state.data[dataConstants.ROOMS];
	} ); // do not remove, required for reloading
	
	const [ returnData, setReturnData ] = useState( {} );
	
	useDeepCompareEffect( () => {
		setReturnData( generateTimeslotGroups( _timeslotGroups, _timeslotKinds, _buildings, _floors, _rooms, _forcedGuids ) );
	}, [ _timeslotGroups, _timeslotKinds, _buildings, _floors, _rooms, _forcedGuids ] );
	
	return returnData;
}

export const generateSelectTimeslotGroupsData = ( forcedGuids ) => {
	let data = store.getState().data;
	
	return generateTimeslotGroups( data[ dataConstants.TIMESLOT_GROUPS ], data[ dataConstants.TIMESLOT_KINDS ], data[ dataConstants.BUILDINGS ], data[ dataConstants.FLOORS ], data[ dataConstants.ROOMS ], forcedGuids );
};

export default useSelectTimeslotGroups
